function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { forwardRef, useState } from 'react';
import { BottomSheetContentLayout } from "../BottomSheet";
import { useOverlayContext } from "../OverlayContext";
import { Typography } from "../Typography";
import { BaseTextField } from "./BaseTextField/BaseTextField";
import { MobileTextFieldTID } from "./BaseTextField/BaseTextField.utils";
import { MobileSummaryCard } from "./MobileSummaryCard";
import styles from "./MobileTextField.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const TextFieldInBottomSheet = /*#__PURE__*/forwardRef(function TextFieldInBottomSheet(props, ref) {
  const {
    hideBottomSheet
  } = useOverlayContext();
  const [tempValue, setTempValue] = useState(props.value);
  function handleSave() {
    if (tempValue !== props.value && props.onChange) {
      props.onChange({
        target: {
          value: tempValue
        }
      });
    }
    hideBottomSheet();
  }
  return /*#__PURE__*/_jsx(BottomSheetContentLayout, {
    contentClassName: styles.bottomSheetContent,
    footer: {
      primaryAction: {
        text: 'Save',
        onClick: () => handleSave()
      }
    },
    children: /*#__PURE__*/_jsx(BaseTextField, _objectSpread(_objectSpread({}, props), {}, {
      value: tempValue,
      onChange: e => setTempValue(e.target.value),
      onKeyDown: () => {},
      ref: ref
    }))
  });
});
export const MobileTextField = /*#__PURE__*/forwardRef(function MobileTextField(props, ref) {
  const {
    testId
  } = props;
  const {
    pushBottomSheetPage
  } = useOverlayContext();
  return /*#__PURE__*/_jsx(MobileSummaryCard, {
    testId: testId,
    title: props.label,
    body: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      children: props.value
    }),
    titleTestId: MobileTextFieldTID.Label(testId),
    bodyTestId: MobileTextFieldTID.Value(testId),
    editButtonTestId: MobileTextFieldTID.EditButton(testId),
    onEdit: () => {
      pushBottomSheetPage({
        content: /*#__PURE__*/_jsx(TextFieldInBottomSheet, _objectSpread(_objectSpread({}, props), {}, {
          ref: ref
        }))
      });
    }
  });
});